// §26.5 / §9.1 — Chat as an in-process app. Gated (D-200): §26.9 puts the whole social layer
// behind a session, so a guest never sees it.
//
// Not lazy, for the same reason Connections is not (D-247 is about *games*): this is a list and a
// text box, and it is the window the §26.6 doorbell sends somebody to. A chunk fetch between "you
// have a message" and the message being on screen is latency at the only moment that matters.
import type { ChatShellAccess, InProcessApp } from '@hangar/shared';
import { createRoot, type Root } from 'react-dom/client';
import { Chat } from './Chat';

export function createChatApp(access: ChatShellAccess): InProcessApp {
  const roots = new WeakMap<HTMLElement, Root>();
  return {
    id: 'chat',
    name: 'Chat',
    icon: { glyph: 'message-square', hue: 150 },
    keywords: ['message', 'messages', 'talk', 'conversation', 'dm', 'social'],
    requiresAuth: true,
    window: { width: 620, height: 520, minWidth: 420, minHeight: 320, multiWindow: false },
    mount(container) {
      const root = createRoot(container);
      roots.set(container, root);
      root.render(<Chat access={access} />);
    },
    unmount(container) {
      const root = roots.get(container);
      roots.delete(container);
      root?.unmount();
    },
  };
}
